import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f717d996"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "scoreImport" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"bold","font-size":"18px","color":"#16a085"} }, "金融数据模板下载", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"bold","font-size":"18px","color":"#2980b9"} }, "维保数据模板下载", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"bold","font-size":"18px","color":"#8e44ad"} }, "线上互动数据模板下载", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"bold","font-size":"18px","color":"#c0392b"} }, "销售数据模板下载", -1))
const _hoisted_7 = { class: "first" }
const _hoisted_8 = { class: "jr" }
const _hoisted_9 = { class: "wb" }
const _hoisted_10 = { class: "second" }
const _hoisted_11 = { class: "xshd" }
const _hoisted_12 = { class: "xs" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_UploadComp = _resolveComponent("UploadComp")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_button, {
        text: "",
        size: "large",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.downLoadResourceFiles({sourceName:'金融上传数据模板.xlsx',downLoadFileName:'金融上传数据模板.xlsx'})))
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        text: "",
        size: "large",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.downLoadResourceFiles({sourceName:'维保上传数据模板.xlsx',downLoadFileName:'维保上传数据模板.xlsx'})))
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        text: "",
        size: "large",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.downLoadResourceFiles({sourceName:'线上互动上传数据模板.xlsx',downLoadFileName:'线上互动上传数据模板.xlsx'})))
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        text: "",
        size: "large",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.downLoadResourceFiles({sourceName:'销售上传数据模板.xlsx',downLoadFileName:'销售上传数据模板.xlsx'})))
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_el_divider),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_UploadComp, _mergeProps(_ctx.buildUploadInitParams({uploadType:'jrDataUpload',type:1,title:'金融数据上传'}), {
          ref: el=>_ctx.refMap.set('jrDataUpload',el)
        }), null, 16)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_UploadComp, _mergeProps(_ctx.buildUploadInitParams({uploadType:'wbDataUpload',type:2,title:'维保数据上传'}), {
          ref: el=>_ctx.refMap.set('wbDataUpload',el)
        }), null, 16)
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_UploadComp, _mergeProps(_ctx.buildUploadInitParams({uploadType:'xshdDataUpload',type:3,title:'线上互动数据上传'}), {
          ref: el=>_ctx.refMap.set('xshdDataUpload',el)
        }), null, 16)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_UploadComp, _mergeProps(_ctx.buildUploadInitParams({uploadType:'xsDataUpload',type:4,title:'销售数据上传'}), {
          ref: el=>_ctx.refMap.set('xsDataUpload',el)
        }), null, 16)
      ])
    ])
  ]))
}